/*eslint-disable */
import React, { useState } from 'react';
import { TextField } from '@mui/material';
import { ContainerAutocomplete } from './styles';

export default function InputAutoSelect({labelInput = "", onFocusInput = () => {}, onChangeOption, ...rest}) {
	const [inputValue, setInputValue] = useState('');
	return (
		<ContainerAutocomplete
			inputValue={inputValue}
			onChange={(evt, select) => {
				onChangeOption(evt, select)
				setInputValue('')
			}}
			onInputChange={(event, newInputValue) => {
				setInputValue(newInputValue);
			}}
			renderInput={(params) => <TextField {...params} onFocus={() => { setInputValue(''); onFocusInput(); }} label={labelInput} variant="outlined" />}
			freeSolo
			filterSelectedOptions
			clearOnEscape
			{...rest}
		/>
  );
}
